export class Tracks {
    digiboard: Digiboard = new Digiboard();
    locationLive: LocationLive = new LocationLive();
    rider: Rider = new Rider();
    customer: Customer = new Customer();
    couponRedemption: CouponRedemption = new CouponRedemption();
    storeReporting: StoreReporting = new StoreReporting();
    spinWinRedemption: SpinWinRedemption = new SpinWinRedemption();
}

export class Digiboard {
    offline: number = 0;
    online: number = 0;
    playingContent: number = 0;
    total: number = 0;
}

export class LocationLive {
    offline: number = 0;
    online: number = 0;
    orders: number = 0;
    total: number = 0;
}

export class Rider {
    offline: number = 0;
    online: number = 0;
    orders: number = 0;
    total: number = 0;
}

export class Customer {
    b2bCustomers: number = 0;
    cartCustomers: number = 0;
    totalCustomers: number = 0;
    webCustomers: number = 0;
}

export class CouponRedemption {
    couponRedemption: number = 0;
    couponCancelled: number = 0;
    totalCoupon: number = 0;
}

export class SpinWinRedemption {
    spinWinGeneration: number = 0;
    spinWinRedemption: number = 0;
    totalSpinWin: number = 0;
}

export class StoreReporting {
    storeReporting: number = 0;
    filterType: string = '';
}

